import keycloak from "../../core/authentication/Keycloak.js";
import {consoleLog} from '../../core/utilities/Utilities.js';
const file='Api.js';

export async function upsertTasks(body){
    let url='/api/upsert_tasks';
    try{
        const fetchResponse=await fetch(url,{
            method:"POST",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${keycloak.token}`,
            },
            body:JSON.stringify(body),
        });
        if(!fetchResponse.ok){
            throw new Error(`HTTP ${fetchResponse.status}: ${fetchResponse.statusText}`);
        }
        const response=await fetchResponse.json();
        return response;
    } 
    catch(e){
        consoleLog({file:file,context:'upsertTasks',arg_name:'e',arg_value:e});
    }
}

export async function previewEventTaskImpact(body){
    let url='/api/preview_event_task_impact';
    try{
        const fetchResponse=await fetch(url,{
            method:"POST",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${keycloak.token}`,
            },
            body:JSON.stringify(body),
        });
        if(!fetchResponse.ok){
            throw new Error(`HTTP ${fetchResponse.status}: ${fetchResponse.statusText}`);
        }
        const response=await fetchResponse.json();
        return response;
    }
    catch(e){
        consoleLog({file:file,context:'previewEventTaskImpact',arg_name:'e',arg_value:e});
    }
}

export async function previewEventExpiration(body){
    let url='/api/preview_event_expiration';
    try{
        const fetchResponse=await fetch(url,{
            method:"POST",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${keycloak.token}`,
            },
            body:JSON.stringify(body),
        });
        if(!fetchResponse.ok){
            throw new Error(`HTTP ${fetchResponse.status}: ${fetchResponse.statusText}`);
        }
        const response=await fetchResponse.json();
        return response;
    }
    catch(e){
        consoleLog({file:file,context:'previewEventExpiration',arg_name:'e',arg_value:e});
    }
}

export async function previewAccountTaskImpact(body){
    let url='/api/preview_account_task_impact';
    try{
        const fetchResponse=await fetch(url,{
            method:"POST",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${keycloak.token}`,
            },
            body:JSON.stringify(body),
        });
        if(!fetchResponse.ok){
            throw new Error(`HTTP ${fetchResponse.status}: ${fetchResponse.statusText}`);
        }
        const response=await fetchResponse.json();
        return response;
    }
    catch(e){
        consoleLog({file:file,context:'previewAccountTaskImpact',arg_name:'e',arg_value:e});
    }
}

export async function getActiveTaskInfo(){
    if(!keycloak.authenticated) return null;
    let url='/api/get_active_task_info';
    try{
        const fetchResponse=await fetch(url,{
            method:"GET",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${keycloak.token}`,
            },
        });
        if(!fetchResponse.ok){
            throw new Error(`HTTP ${fetchResponse.status}: ${fetchResponse.statusText}`);
        }
        const response=await fetchResponse.json();
        return response;
    } 
    catch(e){
        consoleLog({file:file,context:'getActiveTaskInfo',arg_name:'e',arg_value:e});
    }
}

export async function getScheduleByRange(body){
    let responseUI={};
    let url='/api/get_schedule_by_range';
    if(body.params!==undefined&&body.params.length>0){
        for (let param in body.params){
            let paramDelimiter='&';
            if(param==="0"){paramDelimiter='?';}
            url+=paramDelimiter+body.params[param];
        }
    }
    try{
        const fetchResponse=await fetch(url,{
            method:"GET",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${keycloak.token}`,
            }
        });
        if(!fetchResponse.ok){
            throw new Error(`HTTP ${fetchResponse.status}: ${fetchResponse.statusText}`);
        }
        const response=await fetchResponse.json();
        if(response===undefined||response===null){
            consoleLog({file:file,context:'getScheduleByRange',arg_name:'Error',arg_value:"Error - response is 'undefined'/'null'"});
        }
        else{
            responseUI=JSON.parse(JSON.stringify(response));
        }
    }
    catch(e){
        consoleLog({file:file,context:'getScheduleByRange',arg_name:'e',arg_value:e});
        responseUI={error:"Error - getScheduleByRange: "+e.toString()};
    }
    finally{
        return responseUI
    }
}


export async function generateReport(body){
    let responseUI={};
    let url='/api/generate_report/'+body.reportType;
    if(body.reportParams!==undefined&&body.reportParams.length>0){
        for (let reportParam in body.reportParams){
            let paramDelimiter='&';
            if(reportParam==='0'){paramDelimiter='?';}
            url+=paramDelimiter+body.reportParams[reportParam];
        }
    }
    try{
        const fetchResponse=await fetch(url,{
            method:"GET",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${keycloak.token}`,
            }
        });
        if(!fetchResponse.ok){
            throw new Error(`HTTP ${fetchResponse.status}: ${fetchResponse.statusText}`);
        }
        const response=await fetchResponse.json();
        if(response===undefined||response===null){
            consoleLog({file:file,context:'generateReport',arg_name:'Error',arg_value:"Error - response is 'undefined'/'null'"});
        }
        else{
            responseUI=JSON.parse(JSON.stringify(response));
        }
    }
    catch(e){
        consoleLog({file:file,context:'generateReport',arg_name:'e',arg_value:e});
        responseUI={error:"Error - generateReport: "+e.toString()};
    }
    finally{
        return responseUI
    }
}
